import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import ApiLogTable from '../../features/page/user/ApiLogTable'
import useQueryApiLog from '../../hooks/api/user/useQueryApiLog'
import {IApiLog} from '../../apis/user/getApiLog'
import WizPagination from '../../components/pagination/WizPagination'
import WizSelect from '../../components/select/WizSelect'

interface IProps {
    className?: string
}

const ApiLogPage: React.FC<IProps> = ({className}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const [exchange, setExchange] = useState('')

    const {data, refetch} = useQueryApiLog(currentPage, exchange)

    const apiList = useMemo(() => {
        let list: IApiLog[] = []
        data?.data?.map(item => list.push(item))
        return list
    }, [data])

    useEffect(() => {
        refetch()
    }, [currentPage])

    useEffect(() => {
        setCurrentPage(1)
        window.history.pushState('', '', `?exchange=${exchange}&page=${1}`)
        refetch()
    }, [exchange])

    useEffect(() => {
        const currentPageParams = new URLSearchParams(window.location.search).get('page')
        const exchangeParams = new URLSearchParams(window.location.search).get('exchange')
        setCurrentPage(Number(currentPageParams) || 1)
        setExchange(exchangeParams || '')
    }, [])

    return (
        <PageLayout title={'API Log'}>
            <WizSelect
                optionKey="exchange"
                value={exchange}
                onChange={e => {
                    setExchange(e)
                    window.history.pushState('', '', `?exchange=${e}&page=${currentPage}`)
                }}
                className={'md:w-min md:mx-auto'}
            />
            <ApiLogTable data={apiList} className={'mt-[30px]'} />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={e => {
                    setCurrentPage(e)
                    window.history.pushState('', '', `?exchange=${exchange}&page=${e}`)
                }}
            />
        </PageLayout>
    )
}

export default ApiLogPage
